import { action, observable } from 'mobx';
import { IDayzedMonth } from '@honeybook/hbui/dist/components/HBDayPicker/HBDayPicker.types';
import {
    getMonthFormat,
    getDateFormat,
    convertDayzedMonthToMonthFormat
} from '~/common/Schedule/schedule.utils';
import { CXRootStore } from '~/components/ClientExperience/stores/cx-root.store';
import {
    IScheduleAvailabilitiesSingleDateResponse,
    IScheduleAvailabilities,
    TSessionTimeSlot
} from '~/types/server.types';

export class CXScheduleAvailabilitiesStore {
    @observable private scheduleSessionSlots: IScheduleAvailabilities = {};
    @observable hasUserInteractedWithSchedule: boolean = false;

    rootStore: CXRootStore;

    constructor(rootStore: CXRootStore) {
        this.rootStore = rootStore;
    }

    @action.bound
    setScheduleSessionSlots(
        value: IScheduleAvailabilitiesSingleDateResponse[],
        shouldClearData?: boolean
    ) {
        const newSlots = value.reduce((prev, { date, slots }) => {
            const month = getMonthFormat(date);
            if (!prev[month]) {
                prev[month] = {};
            }
            prev[month][date] = slots;
            return prev;
        }, {} as IScheduleAvailabilities);

        this.scheduleSessionSlots = shouldClearData
            ? newSlots
            : { ...this.scheduleSessionSlots, ...newSlots };
    }

    @action.bound
    setHasUserInteractedWithSchedule(value: boolean) {
        this.hasUserInteractedWithSchedule = value;
    }

    getSelectedDaySlots = (selectedDay: Date | string): TSessionTimeSlot[] => {
        const month = getMonthFormat(selectedDay);
        const date = getDateFormat(selectedDay);
        return this.scheduleSessionSlots[month]?.[date];
    };

    isDateHasAvailabilities = (date: Date | string) => {
        return !!this.getSelectedDaySlots(date)?.length;
    };

    isMonthHasAvailabilities = (date: Date | string | IDayzedMonth) => {
        let month: string;
        if (typeof date === 'object' && 'month' in date) {
            month = convertDayzedMonthToMonthFormat(date);
        } else {
            month = getMonthFormat(date);
        }
        return !!this.scheduleSessionSlots[month];
    };
}
